import { Box } from '@mantine/core';
import { type ReactNode } from 'react';

// Body padding shrinks on collapse so each item's leading icon stays centered on the rail centerline.
const COLLAPSED_PADDING_X = 8;

interface SidebarLayoutSlots {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
}

interface SidebarLayoutProps {
  slots: SidebarLayoutSlots;
  /** Collapse to the narrow rail (same layout; labels fade, width animates). */
  collapsed?: boolean;
}

export const SidebarLayout = ({
  slots,
  collapsed = false,
}: SidebarLayoutProps) => (
  <Box
    w={
      collapsed
        ? 'var(--container-sidebar-collapsed)'
        : 'var(--container-sidebar)'
    }
    h="100%"
    display="flex"
    sx={{
      flexDirection: 'column',
      overflowX: 'hidden',
      transition: 'width 200ms ease',
    }}
  >
    {slots.header}
    <Box
      flex={1}
      px={collapsed ? COLLAPSED_PADDING_X : 'md'}
      py="md"
      sx={{
        overflowY: 'auto',
        overflowX: 'hidden',
        transition: 'padding 200ms ease',
      }}
    >
      {slots.body}
    </Box>
    {slots.footer}
  </Box>
);
